import { render, staticRenderFns } from "./PortalSignalement.vue?vue&type=template&id=0ee35896&scoped=true&"
import script from "./PortalSignalement.vue?vue&type=script&lang=js&"
export * from "./PortalSignalement.vue?vue&type=script&lang=js&"
import style0 from "./PortalSignalement.vue?vue&type=style&index=0&id=0ee35896&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ee35896",
  null
  
)

export default component.exports